import { Heading, Secondary, SvgIcon } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import { useRef, useState } from 'react'
import { SlideDown } from 'react-slidedown'

import {
  Partner as PartnerCardProps,
  PartnersOverview as PartnersOverviewProps,
} from '../../partnerships/types/partnerships-page'
import PartnerCard from './partner-card/partner-card'
import styles from './partners-overview.module.css'

export const DEFAULT_PARTNER_CARDS_LENGTH = 5

const PartnersOverview: React.FC<PartnersOverviewProps> = (blok) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const ref = useRef<HTMLAnchorElement>(null)

  const handleClick = () => {
    isExpanded
      ? // User is collapsing the expanded list
        ref.current?.scrollIntoView?.({ block: 'center' })
      : // User is opening the expanded list
        ref.current?.focus()

    setIsExpanded((prevState) => !prevState)
  }

  const partnerCards = isExpanded
    ? blok.partners
    : blok.partners.slice(0, DEFAULT_PARTNER_CARDS_LENGTH)

  return (
    <section {...storyblokEditable(blok)} className={styles.container}>
      <Heading className={styles.heading}>{blok.heading}</Heading>
      <SlideDown
        as="ul"
        className={styles.listContainer}
        data-expanded={isExpanded}
      >
        {partnerCards.map((partner: PartnerCardProps, idx: number) => (
          <PartnerCard
            {...partner}
            key={partner._uid}
            innerRef={
              idx === DEFAULT_PARTNER_CARDS_LENGTH - 1 ? ref : undefined
            }
          />
        ))}
      </SlideDown>
      <Secondary
        classNames={{ button: styles.button }}
        element="button"
        onClick={() => handleClick()}
      >
        {`Show ${isExpanded ? 'fewer' : 'all'} partnerships`}
        <SvgIcon
          name="chevron-down"
          size={16}
          className={cx(styles.chevronIcon, {
            [styles.chevronIconRotateUp]: isExpanded,
          })}
        />
      </Secondary>
    </section>
  )
}

export default PartnersOverview
